import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const WhatsApp = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9.00503 10C8.91496 9.27436 8.92762 8.57903 9 8H9.38197C9.76074 8 10.107 8.214 10.2764 8.55279C10.4172 8.83431 10.4172 9.16569 10.2764 9.44721C10.107 9.786 9.76074 10 9.38197 10H9.00503ZM9.00503 10C9.28197 12.2313 10.5302 14.7492 14 15.0532M9.00503 10H9M14 15.0532C14.5984 15.1056 15.263 15.0921 16 15V14.618C16 14.2393 15.786 13.893 15.4472 13.7236C15.1657 13.5828 14.8343 13.5828 14.5528 13.7236C14.214 13.893 14 14.2393 14 14.618V15.0532ZM21 12C21 16.9706 16.9706 21 12 21C10.5632 21 9.20496 20.6633 8 20.0645L3 21L4.51555 17C3.55827 15.5699 3 13.8501 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WhatsApp;
